import { Col, CreateTableState, Grid } from 'gu-ui-kit'
import React, { useEffect, useMemo, useState } from 'react'
import { useBreakpoint } from 'utils/hoc/breakpointProvider'
import { useTranslation } from 'react-i18next'
import styles from 'modules/Referral/ReferralLinks/referral.module.scss'
import {
  LinkCell,
  NameCell,
  DateCell,
  EditCell,
} from 'modules/Referral/ReferralLinks/subcomponents'

export const useTableConfig = ({ handleChangeName = () => {} }, data = []) => {
  const breakpoints = useBreakpoint()
  const { t } = useTranslation(['services'])
  const [columnVisibility, setColumnVisibility] = useState()

  useEffect(() => {
    if (!breakpoints.fb) {
        setColumnVisibility({ link: false, created_at: false })
    } else if (!breakpoints.xl) {
        setColumnVisibility({ link: false })
    } else {
        setColumnVisibility({})
    }
  }, [breakpoints])

  const tableConfig = useMemo(
    () => ({
      columns: [
        {
          id: 'name',
          header: t('referral::referral_links.table.head.name'),
          className: styles['referral-links__cell_name'],
          cell: ({ row: { original /*: { name, id, url, created_at }*/ } }) => (
            <Grid cols={1} direction={'column'} gap={8} alignItems={'start'}>
              <Col>
                <NameCell {...original} handleChangeName={handleChangeName} />
              </Col>
              {!breakpoints.xl && (
                <Col>
                  <LinkCell {...original} />
                </Col>
              )}
              {!breakpoints.fb && (
                <Col>
                  <DateCell {...original} />
                </Col>
              )}
            </Grid>
          ),
        },
        {
          id: 'created_at',
          header: t('referral::referral_links.table.head.created_at'),
          className: styles['referral-links__cell-created-at'],
          cell: ({ row: { original } }) => <DateCell {...original} />,
        },
        {
          id: 'link',
          header: t('referral::referral_links.table.head.link'),
          className: styles['referral-links__cell_link'],
          cell: ({ row: { original } }) => <LinkCell {...original} />,
        },
        {
          id: 'actions',
          header: ' ',
          isPlaceholder: true,
          className: styles['referral-links__cell_actions'],
          cell: ({ row: { original } }) => <EditCell {...original} />,
        },
      ],
      state: {
        columnVisibility,
      },
      showHeader: data?.length > 0,
      showFooter: false,
      className: styles['referral-links__table'],
    }),
    [handleChangeName, columnVisibility, data],
  )

  return {
    tableState: CreateTableState(tableConfig, data),
    tableConfig,
  }
}

